import { productListStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsProductList";
import { css } from "styled-components";

productListStyles.container = {
    gap: 0,
    css: css`
        @media print {
            padding-bottom: 120px;
        }
        border-top: 0;
    `,
};
productListStyles.lineGridItem = {
    width: 12,
    css: css`
        border-bottom: 0;
        padding-bottom: 20px;
    `,
};
